import { categories } from '@/mocks/homeData';

export default function CategorySection() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-sm font-semibold text-primary-500 uppercase tracking-wider mb-3">Shop by Category</p>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            Explore Our Product Categories
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Browse through our extensive collection of premium products. Each category is carefully curated and linked to detailed listings on our main store.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative flex flex-col rounded-xl bg-background-100 hover:bg-accent-50 border border-background-200/60 hover:border-accent-200 transition-all duration-300 cursor-pointer overflow-hidden"
            >
              <div className="w-full aspect-square overflow-hidden">
                <img
                  src={cat.image}
                  alt={`${cat.name} category - VigorBuy Spreadsheet`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-3 md:p-4 text-center">
                <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-foreground-900 whitespace-nowrap leading-tight">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}